export default __webpack_public_path__ + "static/media/itching.ca058729.svg";